import { ActionsCell } from "@/molecules/ActionsCell"

import type {
  ActionsAiPolicyCellProps,
  AiPolicyRowRecord
} from "./ActionsAiPolicyCell.types"

// A real policy's menu edits and deletes it, like an SCM policy's: deleting
// asks first, and it is switched on and off in its status column. The demo's
// menu is as it was.
export const ActionsAiPolicyCell = (props: ActionsAiPolicyCellProps) => {
  return function ActionsAiPolicyCellComponent(
    _: unknown,
    record: AiPolicyRowRecord
  ) {
    const { live } = props

    if (live && record.live) {
      return (
        <ActionsCell
          noPermissions={!live.canWrite}
          items={[
            { key: "edit", label: live.t("general.edit") },
            { key: "delete", label: live.t("general.delete") }
          ]}
          onClick={({ key }) => {
            if (key === "edit") live.edit(record)
            if (key === "delete") live.remove(record)
          }}
        />
      )
    }

    const items = [
      { key: "view", label: "View" },
      { key: "delete", label: "Delete" }
    ]

    return (
      <ActionsCell
        items={items}
        onClick={(info) => {
          const { key } = info

          if (key === "view") props.view(record.id)
        }}
      />
    )
  }
}
